module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/linkedin-7982df0bc59caa1cb5684bcec52966ea.svg";